"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.repr = void 0;
const color_1 = require("../../utils/color");
const in_browser_p_1 = require("../../utils/in-browser-p");
const json_1 = require("../../utils/json");
const Value = __importStar(require("../../value"));
// NOTE The format of repr:
// <task> = <grammar>:<choice>@<index> -> <part> ...
// <part> = <grammar>:<choice>@<index> | <grammar>@<index>
const color_mode = (0, in_browser_p_1.in_browser_p)() ? "html" : "escape-code";
const POINTER = (0, color_1.color)("> ", { mode: color_mode, color: "red" });
function repr(task) {
    let s = task.grammar_name + ":" + task.choice_name + "@" + task.index + " -> ";
    for (let i = 0; i < task.parts.length; i++) {
        if (i === task.progress.length) {
            s += POINTER;
        }
        s += repr_part(task.parts[i]);
        if (i < task.progress.length) {
            s += repr_progress_entry(task.progress[i]);
        }
        s += " ";
    }
    return s;
}
exports.repr = repr;
function repr_progress_entry(entry) {
    const { choice_name, index } = entry;
    if (choice_name) {
        return `:${choice_name}@${index}`;
    }
    else {
        return `@${index}`;
    }
}
function repr_part(part) {
    const { name, value } = part;
    const present = Value.present(value, { on_grammar: "only_show_name" });
    let s = "";
    if (typeof present === "string") {
        s += present.toString();
    }
    else if (present instanceof Array) {
        s += JSON.stringify(present);
    }
    else if (present.hasOwnProperty("$pattern")) {
        const [pattern_name] = (0, json_1.assert_json_array)(present["$pattern"]);
        s += pattern_name;
    }
    else {
        s += JSON.stringify(present);
    }
    return name ? repr_named(name, s) : s;
}
function repr_named(name, s) {
    return `(${name}: ${s})`;
}
//# sourceMappingURL=task-repr.js.map